export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  excerpt: string;
}

export const articles: Article[] = [
  {
    id: "post-isekai-guide",
    title: "异世界穿越漫如何挑？三步锁定最适合你的世界观",
    category: "选漫指南",
    date: "2026-08-12",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20fantasy%20manga%20with%20glowing%20world%20portal%20in%20background%2C%20reading%20guide%20concept%2C%20stylized%20illustration%2C%20emerald%20and%20gold%20palette&width=1200&height=750&seq=art-01-isekai-guide&orientation=landscape",
    excerpt:
      "异世界穿越是韩国妖精漫画的常青题材，从魔法学院到国战权谋应有尽有。想高效追更，先看懂世界观的四种基本类型，再按自己的口味精准入坑。",
  },
  {
    id: "post-elf-contract",
    title: "精灵契约题材为何如此上头？契约背后的命运美学",
    category: "题材解析",
    date: "2026-08-08",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=elf%20and%20human%20hands%20bound%20by%20glowing%20contract%20ribbon%20under%20moonlight%2C%20fantasy%20illustration%2C%20silver%20and%20emerald%20tone&width=1200&height=750&seq=art-02-elf-contract&orientation=landscape",
    excerpt:
      "契约不仅仅是力量交换，更意味着命运、记忆与情感的绑定。精灵契约题材以『羁绊』为核心，用细腻的情感刻画牢牢抓住读者的心。",
  },
  {
    id: "post-myth-revival",
    title: "九尾狐、山鬼与龙宫：东方妖怪神话的当代复兴",
    category: "文化观察",
    date: "2026-07-30",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=modern%20reimagining%20of%20east%20asian%20spirits%20in%20urban%20night%20city%2C%20mythological%20illustration%2C%20crimson%20and%20jade%20tone&width=1200&height=750&seq=art-03-myth-revival&orientation=landscape",
    excerpt:
      "当古老的东方神话与现代都市叙事相遇，妖怪不再是只存在于古籍里的存在。神话复兴的背后，是创作者对传统意象的大胆重写。",
  },
  {
    id: "post-weekly-update",
    title: "本周妖精漫画更新速览：这几部新番不容错过",
    category: "更新速递",
    date: "2026-08-18",
    readTime: "4 分钟",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20comic%20release%20schedule%20calendar%20with%20sparkles%20and%20fairy%20dust%2C%20illustration%2C%20warm%20gold%20and%20emerald%20tones&width=1200&height=750&seq=art-04-weekly&orientation=landscape",
    excerpt:
      "《星渊彼端》《月光契约》《狐妖夜行》等热门作品本周均有新章上线，还有多部妖怪神话题材的诚意新作加入片单。",
  },
];